module.exports = __webpack_public_path__ + "img/main-block-specs-preview.a26ee592.png";